import { IHttpService, IPromise, angularFileUpload } from "angular";
import md5 from "md5";

import { UserProfileService } from "./userProfile/profileService";
import { EnvironmentService } from "@gtmhub/env";
import { FileService } from "@gtmhub/files";

export class CurrentUserPictureService {
  public static $inject = ["$http", "Upload", "FileService", "EnvironmentService", "UserProfileService"];

  constructor(
    private $http: IHttpService,
    private $upload: angularFileUpload.IUploadService,
    private fileService: FileService,
    private env: EnvironmentService,
    private profileService: UserProfileService
  ) {}

  public updatePicture(dataUrl: string): IPromise<string> {
    const profile = this.profileService.getProfile();
    const fileName = md5(profile.email);
    const blob = this.$upload.dataUrltoBlob(dataUrl, fileName);

    return this.fileService.uploadAvatarForCurrentUser(blob).then((result) => {
      // get the optimized preset, so we don't serve the super large version
      // add fake version tag in case domain name of account is of the format: 'v' + numbers => leads to wrong pathname to image
      const pictureUrl = result.url.replace("upload/", "upload/q_auto:eco/v100/").replace(".png", ".jpg").replace("http:", "https:");

      const url = this.env.getApiEndpoint("/users/picture");
      return this.$http.post(url, pictureUrl).then(() => {
        const profile = this.profileService.getProfile();
        profile.picture = pictureUrl;
        this.profileService.userProfileUpdated(profile);
        return pictureUrl;
      });
    });
  }
}
